import {
    FETCH_CASH_ORDER_DETAILS,
    RESET_CASH_ORDER_DETAILS,
  } from "../../constants/action.constants";
  
  const initialState = {
    data: {},
  };
  
  const cashOrderDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CASH_ORDER_DETAILS:
        return { data: action.payload };
      case RESET_CASH_ORDER_DETAILS:
        return initialState;
      default:
        return state;
    }
  };
  
  export default cashOrderDetailsReducer;
  